module.exports = __webpack_public_path__ + "img/hopways-02.57c98102.jpeg";